import { apiClient, orgApiPath } from '@/core/api';
import type { ComplianceStatus, Creative, RveCreative } from '@/types/api';

export interface CreativeCreateBody {
  name: string;
  format_id: string;
  template_id: string;
  render_duration_ms?: number | null;
  elements?: unknown[];
  assigned_campaign_ids?: number[];
}

export interface CreativeUpdateBody {
  name?: string | null;
  render_duration_ms?: number | null;
  elements?: unknown[] | null;
  assigned_campaign_ids?: number[] | null;
  thumbnail_url?: string | null;
  rve_creative?: RveCreative | null;
  rve_tracks?: unknown[] | null;
}

export interface ListCreativesParams {
  offset?: number;
  limit?: number;
  campaign_id?: number;
}

export async function listCreatives(params: ListCreativesParams = {}): Promise<Creative[]> {
  const { offset = 0, limit = 50, campaign_id } = params;
  const search = new URLSearchParams({
    offset: String(offset),
    limit: String(limit),
  });
  if (campaign_id != null) {
    search.set('campaign_id', String(campaign_id));
  }
  return apiClient<Creative[]>(orgApiPath(`/creatives?${search.toString()}`));
}

export async function getCreative(id: number): Promise<Creative> {
  return apiClient<Creative>(orgApiPath(`/creatives/${id}`));
}

export interface CreativeComplianceStatusRow {
  creative_id: number;
  creative_generation: number;
  compliance_status: ComplianceStatus | null;
}

export async function getCreativeComplianceStatus(
  id: number,
): Promise<CreativeComplianceStatusRow> {
  return apiClient<CreativeComplianceStatusRow>(
    orgApiPath(`/creatives/${id}/compliance-status`),
  );
}

export async function createCreative(body: CreativeCreateBody): Promise<Creative> {
  return apiClient<Creative>(orgApiPath('/creatives'), {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function updateCreative(id: number, body: CreativeUpdateBody): Promise<Creative> {
  return apiClient<Creative>(orgApiPath(`/creatives/${id}`), {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export async function deleteCreative(id: number): Promise<void> {
  return apiClient<void>(orgApiPath(`/creatives/${id}`), {
    method: 'DELETE',
  });
}
